/**
 * Вид игры. Любительский стол может создать любой игрок, турнирный — только администратор.
 * Статистика, баллы и рейтинг ведутся отдельно по видам.
 */
export const GAME_KINDS = ['AMATEUR', 'TOURNAMENT'] as const;
export type GameKind = (typeof GAME_KINDS)[number];

export const KIND_NAMES: Record<GameKind, string> = {
  AMATEUR: 'Любительская',
  TOURNAMENT: 'Турнирная',
};
